import { render, staticRenderFns } from "./StartHeader.vue?vue&type=template&id=819f8214&scoped=true"
import script from "./StartHeader.vue?vue&type=script&lang=js"
export * from "./StartHeader.vue?vue&type=script&lang=js"
import style0 from "./StartHeader.vue?vue&type=style&index=0&id=819f8214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819f8214",
  null
  
)

export default component.exports